import { TileCoordinates } from "../../../lib/runescape/coordinates/TileCoordinates";
import InteractionTopControl from "../../ui/map/InteractionTopControl";
import { ValueInteraction } from "../../../lib/gamemap/interaction/ValueInteraction";
import { Observable, observe } from "../../../lib/reactive";
import { PathGraphics } from "../../ui/path_graphics";
var arrow = PathGraphics.arrow;
var observe_combined = Observable.observe_combined;
export class DrawArrowInteraction extends ValueInteraction {
    constructor(allow_off_grid) {
        super({
            preview_render: ([from, to]) => {
                return arrow(from, to).setStyle({
                    weight: 3,
                    color: "gold"
                });
            }
        });
        this.allow_off_grid = allow_off_grid;
        this.start_position = observe(null).equality(TileCoordinates.eq2);
        this.previewed_target_position = observe(null).equality(TileCoordinates.eq2);
        this.snap_target_position = observe(true);
        observe_combined({ start: this.start_position, target: this.previewed_target_position, snap: this.snap_target_position })
            .subscribe(({ start, target, snap }) => {
            if (start && target) {
                if (snap)
                    this.preview([start, TileCoordinates.snap(target)]);
                else
                    this.preview([start, target]);
            }
        });
        this.attachTopControl(new InteractionTopControl().setName(`Drawing arrow`));
        this.start_position.subscribe(() => this.updateInstructions(), true);
    }
    updateInstructions() {
        if (!this.top_control)
            return;
        if (this.start_position.value()) {
            this.top_control.setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                .append(c().text(`[Click] target tile to confirm.`))
                .append(this.allow_off_grid ? c().text(`[Shift] to disable tile snapping.`) : undefined)
                .append(c().text(`[Backspace] to reset start tile.`)));
        }
        else {
            this.top_control.setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                .append(c().text(`[Click] tile to set start position.`))
                .append(this.allow_off_grid ? c().text(`[Shift] to disable tile snapping.`) : undefined));
        }
    }
    setStartPosition(pos) {
        this.start_position.set(pos);
        return this;
    }
    eventClick(event) {
        event.onPost(async () => {
            event.stopAllPropagation();
            if (!this.start_position.value()) {
                this.start_position.set(event.coordinates);
            }
            else {
                if (this.snap_target_position.value())
                    this.commit([this.start_position.value(), event.tile()]);
                else
                    this.commit([this.start_position.value(), event.coordinates]);
            }
        });
    }
    eventHover(event) {
        event.onPost(() => {
            if (this.start_position.value()) {
                this.previewed_target_position.set(event.coordinates);
            }
        });
    }
    eventKeyDown(event) {
        event.onPre(() => {
            if (this.start_position.value() != null && event.original.key == "Backspace") {
                event.stopAllPropagation();
                this.start_position.set(null);
            }
        });
        if (this.allow_off_grid) {
            event.onPost(() => {
                if (event.original.key == "Shift")
                    this.snap_target_position.set(false);
            });
        }
    }
    eventKeyUp(event) {
        if (this.allow_off_grid) {
            event.onPost(() => {
                if (event.original.key == "Shift")
                    this.snap_target_position.set(true);
            });
        }
    }
}
